import { render, staticRenderFns } from "./ReviewAbsence.vue?vue&type=template&id=f37034f2"
import script from "./ReviewAbsence.vue?vue&type=script&lang=js"
export * from "./ReviewAbsence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports